import axios from 'axios';
import getToken from 'helpers/auth';
import Swal from 'sweetalert2';

const getconfig = () => {
  return {
    headers: { Authorization: 'Bearer ' + getToken() },
  };
};

export const getStructureReport = (endBlocking, corpId) => {
  return async () => {
    axios
      .get(
        `https://api.metimur.mx/api/corporative_id/${corpId}/corporative_structure`,
        {
          corpId: corpId,
          responseType: 'arraybuffer',
        },
        getconfig()
      )
      .then(function (response) {
        const typeApp = 'application/xls';

        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data], { type: typeApp })
        );
        const link = document.createElement('a');
        let fileName = getFileName(response.headers['content-disposition']);
        link.href = downloadUrl;
        link.setAttribute('download', fileName); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
        endBlocking();
      })
      .catch(function (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response.data.message,
        });
        endBlocking();
      });
  };
};

export const postReportHorarioStarted = (
  endBlocking,
  report,
  corpId,
  group,
  charge
) => {
  return async () => {
    axios({
      method: 'post',
      url: 'https://api.metimur.mx/api/report/excel/consumedemand',
      data: {
        corporative_id: corpId,
        meter_id: report.meter,
        group_ids: group,
        charges_ids: charge,
        year: report.year,
        month: report.month,
        type_report: report.type,
      },
      headers: {
        Authorization: 'Bearer ' + getToken(),
      },
      responseType: 'arraybuffer',
    })
      .then(function (response) {
        let typeApp = 'application/zip';
        if (group.length == 1) {
          typeApp = 'application/xls';
        }

        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data], { type: typeApp })
        );
        const link = document.createElement('a');
        console.log(response);
        let fileName = getFileName(response.headers['content-disposition']);
        link.href = downloadUrl;
        link.setAttribute('download', fileName); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
        endBlocking();
      })
      .catch(function (error) {
        console.log(error);
        endBlocking();
      });
  };
};

function getFileName(disposition) {
  let filename = null;
  if (disposition && disposition.indexOf('attachment') !== -1) {
    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    var matches = filenameRegex.exec(disposition);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
  }

  return filename;
}

export const getReportTotalesStarted = (endBlocking, urlParam) => {
  return async () => {
    axios({
      method: 'get',
      url: urlParam,
      headers: {
        Authorization: 'Bearer ' + getToken(),
      },
      responseType: 'arraybuffer',
    })
      .then(function (response) {
        let typeApp = 'application/xls';

        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data], { type: typeApp })
        );
        const link = document.createElement('a');
        console.log(response);
        let fileName = getFileName(response.headers['content-disposition']);
        link.href = downloadUrl;
        link.setAttribute('download', fileName); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
        endBlocking();
      })
      .catch(function (error) {
        console.log(error);
        endBlocking();
      });
  };
};

export const getReportTotalsByDate = (
  meter,
  group,
  startDate,
  endDate,
  includePrice,
  useBlocking
) => {
  return async () => {
    axios({
      method: 'get',
      url: `https://api.metimur.mx/api/report/excel/totals/meter_id/${meter}/group_ids/${group}/dateStart/${startDate}/dateEnd/${endDate}/${includePrice}`,
      headers: {
        Authorization: 'Bearer ' + getToken(),
      },
      responseType: 'arraybuffer',
    })
      .then((response) => {
        let typeApp = 'application/xls';

        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data], { type: typeApp })
        );
        const link = document.createElement('a');
        let fileName = getFileName(response.headers['content-disposition']);
        link.href = downloadUrl;
        link.setAttribute('download', fileName); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
        Swal.fire({
          icon: 'success',
          title: 'Reporte generado',
          text: 'El reporte se ha generado correctamente',
        });
        useBlocking();
      })
      .catch(function (error) {
        useBlocking();
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response.data.message,
        });
        console.log(error);
      });
  };
};

export const sendReports = (reportData) => {
  return async () => {
    axios({
      method: 'post',
      url: 'https://api.metimur.mx/api/report/schedulereport',
      data: reportData,
      headers: {
        Authorization: 'Bearer ' + getToken(),
      },
      responseType: 'arraybuffer',
    })
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Reporte Programado',
          text: 'El reporte se ha programado correctamente',
        });
      })
      .catch(function (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response.data.message,
        });
      });
  };
};

export const getReports = (user) => {
  return async (dispatch) => {
    axios
      .get(
        'https://api.metimur.mx/api/report/schedulereport',
        {
          user: user,
        },
        getconfig()
      )
      .then((response) => {
        dispatch(getReportSuccess(response.data.data));
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const getReportSuccess = (reports) => {
  return {
    type: 'GET_REPORT_SUCCESS',
    payload: reports,
  };
};

export const deleteReport = (id) => {
  return async (dispatch) => {
    axios
      .delete(
        `https://api.metimur.mx/api/report/schedulereport`,
        {
          data: {
            id: id,
          },
        },
        getconfig()
      )
      .then(() => {
        dispatch(deleteReportSuccess(id));
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const deleteReportSuccess = (id) => {
  return {
    type: 'DELETE_REPORT_SUCCESS',
    payload: id,
  };
};

export const updateReport = (reportData) => {
  return async () => {
    axios({
      method: 'put',
      url: 'https://api.metimur.mx/api/report/schedulereport',
      data: reportData,
      headers: {
        Authorization: 'Bearer ' + getToken(),
      },
      responseType: 'arraybuffer',
    })
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Reporte actualizado',
          text: 'El reporte se ha actualizado correctamente',
        });
      })
      .catch(function (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response.data.message,
        });
      });
  };
};

export const getInvoice = (user) => {
  return async (dispatch) => {
    axios
      .get(
        'https://api.metimur.mx/api/report/scheduleinvoice',
        {
          user: user,
        },
        getconfig()
      )
      .then((response) => {
        dispatch(getInvoiceSuccess(response.data?.data));
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const getInvoiceSuccess = (invoices) => {
  return {
    type: 'GET_INVOICE_SUCCESS',
    payload: invoices,
  };
};

export const sendInvoice = (invoiceData) => {
  return async () => {
    axios({
      method: 'post',
      url: 'https://api.metimur.mx/api/report/scheduleinvoice',
      data: invoiceData,
      headers: {
        Authorization: 'Bearer ' + getToken(),
      },
      responseType: 'arraybuffer',
    })
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Factura Programada',
          text: 'La factura se ha programado correctamente',
        });
      })
      .catch(function (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response.data.message,
        });
      });
  };
};

export const deleteInvoice = (id) => {
  return async (dispatch) => {
    axios
      .delete(
        'https://api.metimur.mx/api/report/scheduleinvoice',
        {
          data: {
            id: id,
          },
        },
        getconfig()
      )
      .then(() => {
        dispatch(deleteInvoiceSuccess(id));
      })
      .catch(function (error) {
        console.log(error);
      });
  };
};

export const deleteInvoiceSuccess = (id) => {
  return {
    type: 'DELETE_INVOICE_SUCCESS',
    payload: id,
  };
};

export const updateInvoice = (invoiceData) => {
  return async () => {
    axios({
      method: 'put',
      url: 'https://api.metimur.mx/api/report/scheduleinvoice',
      data: invoiceData,
      headers: {
        Authorization: 'Bearer ' + getToken(),
      },
      responseType: 'arraybuffer',
    })
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Factura actualizada',
          text: 'La factura se ha actualizado correctamente',
        });
      })
      .catch(function (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response.data.message,
        });
      });
  };
};
